/* eslint-disable eqeqeq */
import React, { useState } from "react";
import { connect } from "react-redux";
import locationIcon from "../../../assets/location.svg";
import { currentLocationInfo } from "../../home/redux/actions";
import {  InputGroup,
   Form,
   ListGroup,
   ListGroupItem} from "react-bootstrap";
import { geocodeAddress, GetLocationList, getRequestcall } from "../util/getRequest";
import { maintainAirportlist } from "../../header/redux/actions";
import { AIRPORT_LIST } from "../../constants/apiurl";
import {useNavigate} from "react-router-dom";
import { reverseGeocode } from "./../util/getRequest";

export const LocationMapList = ({ShowList, OnSelectLocationHandler, cursor, locationList, ResetState}) =>{
  return ShowList === true && 
    <React.Fragment>
      <ListGroup className="menuScroll">
        {locationList?.map((item, index)=>(
            <ListGroupItem id={"innerDivscorll"+index} key={index?.toString()} onClick={(e)=>OnSelectLocationHandler(e, index)} className={cursor === index ? 'actions' : null} >
              {item?.description}
            </ListGroupItem>
        ))}
      </ListGroup>
     {locationList?.length >0 && <div onClick={()=>ResetState()} className="background_click" />}
    </React.Fragment>
}

function PlacesAutocompletePage (props) {
  let currentUrl = window.location.pathname.split("/");
  const navigate = useNavigate();
  const [locationList, SetLocationList] = useState([])
  const [ShowList, SetShowList] = useState(false);
  const [cursor, setCursor] = useState(0)
  const locationValueChange =async (address) => {
    props?.setAddress(address);
    const Responce = await GetLocationList(address);
    if(Responce?.status === "OK"){
      if(!ShowList)
      SetShowList(true)
      SetLocationList(Responce?.predictions);
    }
  };

  const callingPagesaccordingLocation = async (lat, lng, currentLocation) => {
    var timestamp = new Date().getTime();
    if(currentUrl?.length > 0) {
    switch (currentUrl[1]) {
      case "stores":
        if(currentUrl[2]){
          navigate("/stores/"+currentUrl[2], { state: { obj: timestamp } });
        }else{
          navigate("/stores", { state: { obj: timestamp } });
        }
        break;
      case "offers":
        navigate("/offers", { state: { obj: timestamp } });
        break;
      case "":
        callAirportlist(lat, lng, currentLocation);
        break;
      default:
        break;
    }
  }
  };
  
  const callAirportlist = async (lat, lng, currentLocation) => {
    console.log("currentLocation", currentLocation)
    // let CountryList = `?country=${currentLocation?.country}`;
    // if(currentLocation?.country === ""){
    //   CountryList = `?country=${currentLocation?.state}`
    // }
    // if(currentLocation?.country === "India"){
    //   CountryList = `?country=${currentLocation?.state}`;
    //   if(currentLocation?.country === ""){
    //     CountryList = `?country=${currentLocation?.state}`
    //   }
    // }
    const CountryList = `?lat=${currentLocation?.lat}&lng=${currentLocation?.lng}`
    let geturl = AIRPORT_LIST + CountryList;
    let getListing = await getRequestcall(geturl, "");
    if (getListing?.status === 200) {
      let list = await getListing.json();
      let airport = {};
      let airportList = [];
      list.results.forEach((item) => {
        airport = {
          name: item.name,
          lat: item.geometry.location.lat,
          lng: item.geometry.location.lng,
        };
        airportList.push(airport);
      });
      props.maintainAirportlist(airportList);
    }
  };
  
  const OnSelectLocationHandler =async (e, index) =>{
    e.preventDefault();
    const SelectList = locationList?.filter((item, index1)=>index === index1);
    if(SelectList?.length >0){
      getGeoCode(SelectList[0]?.description)
    }else{
      getGeoCode(props?.address)
    }
    SetShowList(false)
    SetLocationList([])
   
  }
  const SetLocation =async ({place,Lat, lng, ZipCode }) =>{
    let isocode = "";
    props?.setAddress("");
    props?.setPlaceaddress(place?.formatted_address);
    let currentLocation = {
      lat: Lat,
      lng: lng,
      address: "",
      selectedLocation: place?.formatted_address,
      city: "",
      country: "",
      state: "",
      zip_code: ZipCode,
      isocode: "",
    };
      place.address_components.forEach((item) => {
      switch (item.types[0]) {
        case "locality":
          currentLocation.city = item.long_name;
          break;
        case "administrative_area_level_1":
          currentLocation.state = item.long_name;
          break;
        case "country":
          currentLocation.country = item.long_name;
          isocode = item.short_name;
          break;
        default:
          break;
      }
    });
  currentLocation.isocode = isocode;
    currentLocation.address =
      currentLocation.city +
      " " +
      currentLocation.state +
      " " +
      currentLocation.country +
      " " +
      currentLocation.zip_code;
    await props.currentLocationInfo(currentLocation);
    callingPagesaccordingLocation(Lat,lng,currentLocation);
  }
  const getGeoCode = async (address) =>{
    const responce = await geocodeAddress(address);
    if(responce?.status === "OK" && responce?.results){
        const place  = responce?.results[0];
        const Lat = place?.geometry?.location?.lat;
        const lng = place?.geometry?.location?.lng;
        const ZipCode  = await reverseGeocode({ latitude:Lat, longitude:lng });
        SetLocation({place,Lat, lng, ZipCode })
    }
    // const geocoder = new window.google.maps.Geocoder();
    // geocoder.geocode({'address': address},async function(results, status) {
    //     if (status == window.google.maps.GeocoderStatus.OK) {
    //       if(results){
    //         const place = results[0];
    //         const Lat = place?.geometry?.location?.lat();
    //         const lng = place?.geometry?.location?.lng();
    //         const ZipCode  = await reverseGeocode({ latitude:Lat, longitude:lng });
    //         SetLocation({place,Lat, lng, ZipCode })
    //       }
    //     }
    // });
  }
  const handleKeyDown = (e) =>{
    // arrow up/down button should select next/previous list element
    if(e.key === 'Enter'){
      OnSelectLocationHandler(e, cursor)
    }else if (e.keyCode === 38 && cursor > 0) {
      setCursor(cursor - 1)
    } else if (e.keyCode === 40 && cursor < locationList.length - 1) {
      setCursor(cursor + 1)
    }
  }
  const ResetState = () =>{
    SetShowList(false)
    SetLocationList([])
  }
  return (
    <React.Fragment>
      <div className="header-location position-relative Location_dropdown transition">
          <InputGroup onClick={()=>SetShowList(true)} htmlFor={"Location_Search1"} >
            <InputGroup.Text id="inputGroup-sizing-sm">
              <label>
              <img src={locationIcon} height={"18"} width={"18"} alt="location"></img>
              </label>
            </InputGroup.Text>
            <Form.Control
              placeholder={props?.placaddress? props?.placaddress: props.currentLocation.selectedLocation}
              value={props?.address}
              onChange={(e)=>locationValueChange(e.target.value)}
              id={"Location_Search1"}
              onKeyDown={ handleKeyDown }
            />
          </InputGroup>
        <LocationMapList ShowList={ShowList} locationList={locationList} ResetState={ResetState} OnSelectLocationHandler={OnSelectLocationHandler} cursor={cursor} />
      </div>
      {/* <PlacesAutocomplete
        name="address"
        value={props?.address}
        onSelect={getSelectedlocation}
        onChange={locationValueChange}
      >
        {({
          getInputProps,
          suggestions,
          getSuggestionItemProps,
          loading,
        }) => (
          <div className="header-location">
            <InputGroup htmlFor={"Location_Search"}>
              <InputGroup.Text>
                <img src={locationIcon} height={"18"} width={"18"} alt=""></img>
              </InputGroup.Text>
              <FormControl
                type="text"
                {...getInputProps({
                  placeholder: props?.placaddress
                  ? props?.placaddress
                  : props.currentLocation.selectedLocation,
                })}
                id={"Location_Search"}
                className="location-auto-header"
              />
            </InputGroup>
            <div className="location-place">
              {suggestions.map((suggestion) => {
                const style = {
                  backgroundColor: suggestion.active
                    ? "white"
                    : "white",
                  marginLeft: "0px",
                  fontSize: "16px",
                  boxShadow: "rgb(232 232 232) 0px -0.5px 0px inset",
                  padding: "10px",
                };
                return (
                  <div
                    {...getSuggestionItemProps(suggestion, {
                      style,
                    })}
                  >
                    {suggestion.description}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </PlacesAutocomplete> */}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => ({
    currentLocation: state?.home?.currentLocation,
});

export default connect(mapStateToProps,{currentLocationInfo,maintainAirportlist})(PlacesAutocompletePage);